import { render, staticRenderFns } from "./create-action.vue?vue&type=template&id=5d0cb980"
import script from "./create-action.vue?vue&type=script&lang=js"
export * from "./create-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports